import TemporaryWallets from './TemporaryWallets';

export default TemporaryWallets;
